module.exports = __webpack_public_path__ + "static/world-map-small-ab9fb2538eb5c0292d29db42d17545f2.png";